<template>
  <div>
    <headerTop></headerTop>
    <div style="margin-left: 90%;">
      <el-button plain type="primary" @click="copeFindSource()">发起相似询价</el-button>
    </div>
    <el-row style="background: #f6f6f8">
      <div style="width: 95%; margin: 5px auto">
        <el-form ref="form" :model="form" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="询价标题：">
                <el-input v-model="form.findSourceTitle" style="width: 370px" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="询价单号：">
                <el-input style="width: 370px" :disabled="disabled" type="text" v-model="form.findSourceCode">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称：" prop="projectName">
                <el-input style="width: 370px" type="text" :disabled="true" v-model="form.projectName">
                  <el-button slot="append" icon="el-icon-search" @click="checkName(form.projectName)"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收货地址：">
                <el-cascader style="width: 370px" :disabled="disabled" v-model="addressVal" :options="options"
                  :props="{ expandTrigger: 'hover' }" @change="handleChange" clearable filterable placeholder="搜索">
                </el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="详细地址：">
                <el-input v-model="form.detail" style="width: 370px" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预期回复日期：">
                <el-date-picker :disabled="disabled" v-model="form.expectDate" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="请选择日期" style="width: 370px">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="需求日期：">
                <el-date-picker :disabled="disabled" v-model="form.demandDate" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="请选择日期" style="width: 370px">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格有效期：">
                <el-date-picker :disabled="disabled" v-model="form.expiryDate" type="datetime" placeholder="请选择日期"
                  style="width: 370px">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注：">
                <el-input style="width: 370px" :disabled="disabled" type="textarea"
                  :autosize="{ minRows: 2, maxRows: 10 }" v-model="form.remark">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.status === 5">
              <el-form-item label="退回原因">
                <el-input style="width: 370px" :disabled="true" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
                  placeholder="请输入内容" v-model="form.backMark">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="附件：" v-if="showFile">
            <el-table :data="yxAttachFileList" border stripe :show-header="false" style="width: 550px"
              v-if="yxAttachFileList.length > 0">
              <el-table-column prop="FileName" label="文件名称">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a @click="linkDownload(scope.row.fileUrl)">{{
                      scope.row.fileName
                    }}</a>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a target="_blank" :href="scope.row.fileUrl">下载</a>
                  </el-button>
                </template>
              </el-table-column>

            </el-table>
          </el-form-item>
          <el-form-item style="margin: 0px -100px" v-if="!disabled">
            <el-upload :auto-upload="false" action="#" :file-list="[]" style="float: left" :on-change="handleChange1"
              :data="{ type: 1 }" multiple>
              <el-button type="success" size="small">Excel清单上传</el-button>
            </el-upload>
            <el-button type="primary" @click="addList()" size="small" style="margin-left: 30px">增加</el-button>
            <el-button type="warning" @click="dowExcel()" size="small">下载模版</el-button>
          </el-form-item>
          <el-form-item style="margin: 0px -100px" v-if="disabled">
            <el-button type="primary" @click="downData()" style="margin-left: 30px" size="small">导出</el-button>
          </el-form-item>
          <el-table :key="isUpdate" :data="detailList" style="width: 100%" stripe border fixed height="300px"
            @selection-change="handleSelectionChange" :header-cell-style="{
              background: '#EEEEEE',
              height: '50px',
              color: 'black',
              border: '1px solid #d3d3d3',
            }">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column width="100" align="center" prop="lineCode" label="行号">
            </el-table-column>
            <el-table-column prop="requirementStoreName" label="清单商品名称" align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="requirementStoreSpec" align="center" label="清单规格" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="demandCount" label="需求数量" align="center">
            </el-table-column>
            <el-table-column prop="requirementStoreUnit" label="清单单位" align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" prop="productName" align="center" label="商品名称"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" prop="productCode" align="center" label="商品编码"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <!-- <el-table-column v-if="form.status !== 1 && form.status !== 2" align="center" prop="materialName" label="物料名称"
              :show-overflow-tooltip='true'> -->
            </el-table-column>
            <el-table-column prop="status" label="下单状态" v-if="form.status !== 1 && form.status !== 2">
              <template slot-scope="scope">
                <div>
                  <el-tag v-if="scope.row.isOrder === 0" :type="''">未下单</el-tag>
                  <el-tag v-else-if="scope.row.isOrder === 1" :type="''">已下单</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" prop="sellingPrice" align="center" label="单价">
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" prop="sellingPrice" align="center" label="小计">
              <template slot-scope="scope">
                <span>{{
                  (Number(scope.row.sellingPrice) * Number(scope.row.demandCount)).toFixed(1)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" prop="itemSpecs" align="center" label="规格"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" align="center" prop="materialCode" label="物料编码"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column v-if="form.status !== 1 && form.status !== 2" align="center" prop="materialName" label="物料名称"
              :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="300" v-if="!disabled">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="delList(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <span style="float:right;margin:20px  0" v-if="form.status !== 1 && form.status !== 2">{{
            this.containFreight ?
            '(本报价包含运费)' : '(本报价不含运费)'
          }}</span>
          <span class="col-47" style="float:right;margin:20px " v-if="form.status !== 1 && form.status !== 2">总计：¥{{
            this.totalPrice }}</span>

          <el-form-item style="margin: 10px -80px">
            <el-upload class="upload-demo" :action="action" v-if="form.status !== 1 && form.status !== 2"
              :headers="headers" :on-preview="handlePreview" :on-success="AttachOnSuccess" multiple :limit="8"
              :show-file-list="showlist">
              <el-button size="small" type="primary">上传附件</el-button>
            </el-upload>
            <el-table :data="newList" border stripe :show-header="false" style="width: 550px" v-if="newList.length > 0">
              <el-table-column prop="FileName" label="文件名称">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a @click="linkDownload(scope.row.fileUrl)">{{
                      scope.row.fileName
                    }}</a>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot-scope="scope">
                  <el-button size="small" type="text">
                    <a target="_blank" :href="scope.row.fileUrl">下载</a>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="deleteButton(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item style="margin-left: 30%; margin-top: 20px">
            <el-button type="success" @click="quicklyOrder"
              v-if="form.status !== 1 && form.status !== 2 && form.status !== 4 && form.status !== 5">快速下单</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-dialog title="合同条款及规则" :close-on-press-escape="false" :close-on-click-modal="false"
      style="width: 145%; left: -300px; top:-80px" center :visible.sync="centerDialogVisible">
      <el-scrollbar style="height:500px">

        第一条 定义</br>
        1.1一般货物：由乙方根据技术协议确定的技术标准生产并根据本合同销售给甲方的货物。</br>
        1.2技术协议：指由甲方和乙方签署的确定对其适用的技术标准的协议，本合同的全部技术标准应在技术协议中约定。</br>
        1.3技术资料：与一般货物设计、生产、制造、验收、检验、安装、运行等有关的一切设计图纸、生产图纸、工艺文件、流程图、说明书、零件图册、操作手册（规范）等文件。双方应在技术协议中对技术资料的具体范围进行详细规定。</br>
        第二条 包装</br>
        2.1
        货物由乙方合理包装并符合技术附件的要求（如有），适合水运或长途内陆运输，具有防潮，防湿，防震，防锈功能，符合甲方使用要求。危险品包装需符合国家和地方安全环保规定。如因包装不当给甲方或其他第三方造成的损失和责任均由乙方承担。</br>
        2.2 乙方应根据货物运输要求，于每件包装上印刷包装编号、尺码、毛重、净重、提吊位置及“此端向上”、“小心轻放”，“切勿受潮”等注意事项，由于包装不当而造成的损失均由乙方承担。</br>
        2.3 包装物由乙方提供，#{条款.14.业务条款内容}，其他包装物约定：#{条款.15.业务条款内容}。</br>
        第三条 合理耗损</br>
        以双方共同确定的计量方式为准，合理损耗为（#{条款.16.业务条款内容}）%，实际交付的货物数量在本合同约定的损耗范围内（含），乙方不承担违约责任。</br>
        第四条 溢、短装</br>
        合同溢、短装为合同数量的±#{条款.17.业务条款内容}%。实际数量在溢短装范围内的，按实际交付数量结算；溢装超出范围的，甲方不另付款，短装超出范围的，乙方应补足并承担违约责任。</br>
        第五条 标的物的风险及所有权的转移</br>
        5.1 标的物的风险自甲方验收合格后转移至甲方。标的物在未经甲方验收合格前的毁损、灭失等其他一切风险由乙方负责。</br>
        5.2 标的物的所有权自交付时起转移至甲方。</br>
        5.3 乙方迟延交付的，承担迟延期间标的物的风险责任。货物经甲方同意分批发运的，每批货物的风险及所有权按照5.1、5.2款规定转移。</br>
        第六条 验收</br>
        6.1 验收标准：按本合同约定的质量标准进行检验。</br>
        6.2 若乙方知道或者应当知道所卖出货物存在质量缺陷，所承担的质量保证期不受前款约定质保期的约束，甲方有权无条件退换货，直到达到合同要求；若更换后仍不能达到甲方要求，甲方有权另行采购，所产生的的费用由乙方承担。</br>
        6.3 验收地点：在甲方指定的地点对货物进行验收。</br>
        6.4 货物验收不合格的，甲方有权拒收货物，由此产生的损失及违约责任，由乙方承担。</br>
        6.5
        如双方对货物是否存在质量问题有争议，应由共同确认的检验机构对封存的样品进行检验，并以该检验机构的检验结果作为确认货物质量的依据。如检验结果证明货物不符合合同约定的质量标准，检验费由乙方承担；符合质量标准的，检验费由甲方承担。</br>
        第七条 知识产权和保密</br>
        7.1
        乙方保证提供给甲方的货物、服务和技术附件等文件，不侵犯任何第三方关于专利、商标、版权或工业设计权利等知识产权。如因购买、使用乙方提供的上述服务或使用乙方提供的上述物品而受到第三方对于甲方侵犯其知识产权诉讼和索赔，将由乙方承担由此引发的一切责任和后果。</br>
        7.2 如发生本条第7.1款约定的任何侵犯第三方知识产权侵权，甲方应通知乙方，乙方应立即负责与第三方交涉处理此事，并承担一切由此引起的法律和经济责任，使甲方免受因第三方索赔而承担法律及经济责任所造成的损失。</br>
        7.3 如发生侵权事件或存在侵权可能性，乙方应在知晓该时间之日起48小时内书面通知甲方，并采取合理措施消除影响。</br>
        7.4
        任何一方为履行本协议项下或与本协议相关义务，而向另一方提供的包括但不限于专有技术、技术文件、设计图纸、商业资料等文件资料，接受方应承担保密义务，除为履行本协议或与本协议相关义务目的除外，未经提供方书面同意，均不得提供给任何其他第三方。</br>
        7.5 任何一方均不得将本合同的存在及内容作为商业宣传资料，乙方不得通过甲方提供的信息、渠道等，与上下游公司等关联方洽谈业务，进行商业合作。</br>
        第八条 违约责任</br>
        8.1 如乙方未按期交货 (不可抗力除外)，应承担以下迟交货违约责任:</br>
        （1）每迟交1日历日应支付迟交部分货值千分之五 的违约金，乙方支付违约金并不解除其交货义务，交货时间由双方另行商定。</br>
        （2）逾期交货超过（ 30 ）个日历日，甲方有权按本合同约定解除本合同或采购订单。乙方除支付迟交货违约金外还应赔偿因此给需方造成的损失。</br>
        （3）分期交货情况下，如乙方部分交货延迟导致合同被单方解除，甲方有权就已接收部分货物向乙方要求退货，乙方应退还该部分货款、承担退货费用并赔偿因此给甲方造成的损失。</br>
        8.2 如乙方交付的货物不符合约定的数量，乙方应当承担合同总金额20%的违约金并在甲方要求的期限内补足。</br>
        8.3
        如乙方交付的货物不符合本协议的质量要求和规定指标，甲方有权拒收货物并要求乙方更换，乙方应在甲方要求的期限内提供合格货物，并承担迟延交货的违约责任。如乙方未在该期限内提供合格货物的，甲方有权解除合同并由乙方承担因此给甲方造成的损失。</br>
        8.4 如乙方发生本条所述违约行为未向甲方支付合同金额的百分之二十的违约金，甲方有权从应付货款中直接扣除，但应当书面通知乙方。</br>
        8.5如果合同一方未能履行其在本合同项下的合规义务，守约方可书面通知违约方并要求违约方在收到该通知之日起三十（30）日内对该违约予以补救。如果该违约无法补救，或未能在规定时间内予以补救，守约方有权解除合同。因违约方的违约行为导致守约方承担责任或遭受损失，守约方有权要求违约方给予经济赔偿。</br>
        8.6如发生本条或本协议其他条款未尽的其它违约情形，违约方应赔偿由此给守约方造成的损失。如违约系双方过错造成，应按各自责任比例承担违约责任。</br>
        第九条 不可抗力</br>
        由于不可抗力导致合同一方或双方不能部分或者全部履行本合同义务，受不可抗力影响的合同方将得以免除部分或全部不能履行合同义务的责任，但应在不可抗力发生后24小时内通知对方，并在通知后14个工作日内向对方提供有效证明文件。受不可抗力影响的合同方有义务采取措施将不可抗力造成的损失降到最低。如不可抗力时间持续超过60个日历日，则甲方有权选择终止本合同。此种情况下，双方应妥善协商及处理各项合同事宜。</br>
        第十条 争议解决</br>
        凡与本合同有关或因本合同引起的任何争议，包括但不限于合同的违反、解除、终止和效力应由双方友好协商解决，经双方协商未达成一致的，按（ 2 ）执行：</br>
        （1）任何一方可将该争议向甲方所在地法院提起诉讼；</br>
        （2）任何一方可将该争议向（德州）仲裁委员会提起仲裁；</br>
        （3）甲乙双方均为格瑞德内部单位的，应将任何争议提交格瑞德内部法律纠纷调解小组调处。</br>
        第十一条 变更和解除</br>
        11.1 本合同的变更需经双方协商一致，变更合同自双方签字盖章后生效。在变更合同签署生效前，任何一方应保证本合同正常执行。</br>
        11.2
        甲方有权部分或全部解除采购合同并就解除部分中乙方不能自行处理或没有其他用途的部分向乙方提供合理补偿。补偿范围仅限于由该解除使乙方实际产生的直接合理的费用，包括已购原材料，生产成本及合理的管理费用。乙方应提供已投入生产的成本证据。甲方支付补偿后，取得被解除采购合同下原材料的所有权，乙方应根据甲方要求在合理期限内免费为甲方储存和保管。</br>
        11.3 有下列情形之一者，甲方有权立即单方解除本合同，乙方应赔偿因解除给甲方造成的损失：</br>
        （1）未经甲方书面同意，将部分或全部权利义务转让给第三方。</br>
        （2）在合同有效期内，货物出现重大质量问题。</br>
        （3）乙方延迟交货超过（ 30 ）个日历日。</br>
        （4）乙方发生破产、清算等情况，丧失履约能力。</br>
        （5）乙方有其他严重违约行为，导致本合同目的无法实现。</br>
        （6）被格瑞德集团暂停交易资格或从供应商网络中除名的。</br>
        第十二条 商业道德</br>
        甲乙签署的有关廉洁从业的文件作为本合同的组成部分，与本合同具有同等法律效力。双方违反该合同之行为，应被视为违反本合同的违约行为，应向未违约方承担相应的违约责任。</br>
        第十三条 健康、安全和环境保护</br>
        乙方应在设备生产、存储、运输、交付、安装调试、验收等过程中，遵守中华人民共和国质量、安全、环境与健康等法律法规的有关要求，并承担质量、安全、环境与健康责任。乙方还应遵守甲方的HSSE要求。</br>
        第十四条 通知</br>
        本合同要求的或允许的任何通知、要求或其他书面文件应当由发出该通知的一方书面签署，并以专人送递或邮寄的方式送至对方联系人地址，合同中约定的双方地址即为默认送达地址，如发生变更，应及时通知合同相对方，在取得对方接收确认或到达指定电子通讯设施后，即被认为已送达。</br>
        第十五条 生效及其他</br>
        15.1合同各方保证其根据其成立地的法律依法定程序设立，有效存在且相关手续完备，已取得开展合同项下业务所需的所有政府审批、许可或资质；合同各方知晓并将严格遵守与执行本合同相关的法律法规、监管规则、标准规范，依法依规行使合同权利，履行合同义务，不得从事任何可能导致合同方承担任何行政、刑事责任或处罚的行为。</br>
        </span>

      </el-scrollbar>
      <el-checkbox v-model="checked" style="margin:20px 50px" @change="offCheck">同意此协议</el-checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="agree()">同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getToken } from "@/axios/cookies.js";
import { uploads } from "@/api/user.js";
import { getCityData, getAddressData } from "@/api/user.js";
import { getUserInfo } from "@/api/login.js";
import headerTop from "@/components/base/headerTop.vue";
import { selectAgreementByUid, AddUserAgreement } from "@/api/cart.js";
import {
  saveInventory,
  getFindSourcePriceInfo,
  fastCreateOrderNew,
} from "@/api/noticedetail.js";
import bpm from "./bpm.vue";
import names from "./names.vue";
import { mapGetters } from "vuex";
export default {
  name: "notice",
  components: { bpm, names, headerTop },
  data() {
    return {
      yxAttachFileList: [],
      showFile: true,
      showlist: false,
      headers: {
        Authorization: getToken(),
        tenantId: "0000",
      },
      fileList: [],
      newList: [],
      action: uploads,
      checked: false,
      check: false,
      centerDialogVisible: false,
      totalPrice: "",
      disabled: false,
      lineCode: 1,
      isUpdate: true,
      options: null,
      uItem: null,
      addressList: [],
      switchVisible: false,
      userName: "",
      phone: "",
      askGoods: [],
      userId: null,
      form: {
        projcetSMcode: "",
        projcetSMuser: "",
        id: null,
        projectId: null,
        projectName: "",
        projectCode: "",
        defaultAddress: null,
        address: {
          city: null,
          cityId: null,
          cityCode: null,
          districtCode: null,
          provinceCode: null,
          province: null,
          district: null,
        },
        status: null,
        detail: null,
        businessUserId: "",
        businessUserName: "",
        expectDate: "",
        demandDate: "",
        remark: "",
        createUserType: "",
      },
      detailList: [],
      addressIndex: null,
      uid: null,
      containFreight: null,
      rowData: {},
      dialogTableVisible: false,
      dialogName: false,
      nItem: null,
      addressVal: [],
      upList: [],
    };
  },
  computed: {
    setLineCode() {
      if (this.detailList.length) {
        return (
          Math.max.apply(
            Math,
            this.detailList.map((item) => {
              return item.lineCode;
            })
          ) + 1
        );
      } else {
        return 1;
      }
    },
    ...mapGetters([
      "user", // 用户信息
      "uploadApi",
    ]),
  },
  watch: {
    options: {
      handler(nVal, oVal) {
        // console.log(nVal, oVal)
      },
      deep: true,
    },
  },
  async created() {
    await this.getCityList();
    this.getUserInfo();
    this.disabled = true;
    this.getDetail(this.$route.query.id);
  },

  methods: {
    //发起相似询价单
    copeFindSource() {
      this.$router.push({
        name: "addInventory",
        query: { id: this.$route.query.id, type: "see" },
      });
    },
    AttachOnSuccess(response, file, fileList) {
      let fileArray = {
        fileName: response.link[0].fileName,
        fileUrl: response.link[0].fileUrl,
      };
      if (this.newList == null) {
        this.newList = new Array();
        this.newList.push(fileArray);
      } else {
        this.newList.push(fileArray);
      }
    },
    deleteButton(index) {
      this.newList.splice(index, 1);
    },
    handleRemove(file, fileList) {
      this.newList = file;
    },
    handlePreview(file) {
      console.log(file);
    },
    offCheck() {
      this.check = !this.check;
    },
    async agree() {
      if (this.check) {
        let para = {
          userUid: this.userId,
          agreement: 1,
        };
        var res = await AddUserAgreement(para);
        if (res === true) {
          this.centerDialogVisible = false;
          this.$message({
            message: "同意协议成功",
            type: "success",
          });
        }
      } else {
        this.$message({
          message: "请勾选同意协议",
          type: "warning",
        });
      }
    },
    // 获取用户信息
    async getUserInfo() {
      var res = await getUserInfo();
      if (res.status === 200) {
        this.userId = res.data.uid;
        this.userName = res.data.username;
        this.phone = res.data.phone;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 快速下单
    async seet() {
      let listGoods = this.askGoods.map((item) => ({
        sellingPrice: item.sellingPrice,
        uniqueId: item.productCode,
        remark: item.remark,
        costPrice: item.taxPrice,
        new: 0,
        lineCode: item.lineCode,
        cartNum: item.demandCount,
      }));
      let para = {};
      para["fileList"] = this.newList;
      para["address"] = this.form.address;
      para["cartParamQuickList"] = listGoods;
      para["detail"] = this.form.detail;
      para["demandDate"] = this.form.demandDate;
      para["from"] = "pc";
      para["isChannel"] = "";
      para["payType"] = "remittance";
      para["projectCode"] = this.form.projectCode;
      para["projectName"] = this.form.projectName;
      para["projectId"] = this.form.projectId;
      para["remake"] = this.form.remark;
      para["username"] = this.form.username;
      para["phone"] = this.form.phone;
      para["findSourcePriceMainId"] = this.form.id;
      para["businessManId"] = this.userId;
      var res = await fastCreateOrderNew(para);
      if (res.status === 200) {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        // 链接到订单中的待发货
        this.$router.push("/myOrder");
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
      }
    },

    // 快速下单
    async quicklyOrder() {
      if (this.askGoods.length == 0) {
        this.$message.warning("请选择要下单的商品");
        return;
      }
      let paras = {
        uid: this.userId,
      };
      var res = await selectAgreementByUid(paras);
      if (res === true) {
        this.seet();
      } else {
        this.centerDialogVisible = true;
      }
    },
    checkUpList() {
      this.upList.forEach((item) => {
        item.lineCode = this.setLineCode;
        this.detailList.push(item);
      });
    },
    // 导入函数
    importfxx(obj) {
      let _this = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; // 是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; // 是否将文件读取为二进制字符串
        var wb; // 读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              // 手动转化
              type: "base64",
              cellDates: true,
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
              cellDates: true,
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          this.da = [...outdata];
          _this.lists = outdata;
          let lists = [];
          outdata.map((v) => {
            let obj = {};
            obj.requirementStoreName = v["商品名称"];
            obj.requirementStoreSpec = v["规格"];
            (obj.demandCount = v["需求数量"]), lists.push(obj);
          });
          _this.upList = lists;
          _this.checkUpList();
        };
        reader.readAsArrayBuffer(f);
      };

      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    // 判断文件是否符合要求
    handleChange1(file, fileList) {
      this.fileTemp = file.raw;
      if (this.fileTemp) {
        if (
          this.fileTemp.name.indexOf("xls") != -1 ||
          this.fileTemp.name.indexOf("xlsx") != -1
        ) {
          this.importfxx(this.fileTemp);
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！",
            duration: 10000,
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！",
          duration: 10000,
        });
      }
    },
    // 下载模板
    dowExcel() {
      var header = ["商品名称", "规格", "需求数量"];
      var filter = [
        "requirementStoreName",
        "requirementStoreSpec",
        "demandCount",
      ];
      var name = "项目清单模版";
      let data = [
        {
          requirementStoreName: "XXX",
          requirementStoreSpec: "规格内容",
          demandCount: "100",
        },
      ];
      this.excelData(data, header, filter, name);
    },
    downData() {
      var header = [
        "行号",
        "清单商品名称",
        "清单规格",
        "需求数量",
        "商品名称",
        "商品编码",
        "单位名称",
        "单价",
        "规格",
        "物料编码",
        "物料名称",
      ];
      var filter = [
        "lineCode",
        "requirementStoreName",
        "requirementStoreSpec",
        "demandCount",
        "productName",
        "productCode",
        "unitName",
        "taxPrice",
        "itemSpecs",
        "materialCode",
        "materialName",
      ];
      var name = "询价单详情";
      this.excelData(this.detailList, header, filter, name);
    },
    excelData(res, header, filter, name) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../quickly/Export2Excel");
        const tHeader = header;
        const filterVal = filter;
        const list = res;
        const data = this.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, name);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleSelectionChange(val) {
      this.askGoods = val;
      this.totalPrice = 0;
      this.askGoods.forEach((i) => {
        this.totalPrice += Number(i.demandCount) * Number(i.sellingPrice).toFixed(1);
      });
    },
    getDetail(id) {
      getFindSourcePriceInfo({ id: id })
        .then((res) => {
          this.yxAttachFileList = res.yxAttachFileList;
          this.form.username = res.username;
          this.form.backMark = res.backMark
          this.form.phone = res.phone;
          this.form.status = res.status;
          this.form.demandDate = res.demandDate;
          this.form.expectDate = res.expectDate;
          this.form.address.city = res.city;
          this.form.address.cityId = res.cityId;
          this.form.address.province = res.province;
          this.form.address.cityCode = res.cityCode;
          this.form.address.district = res.district;
          this.form.address.provinceCode = res.provinceCode;
          this.form.address.districtCode = res.districtCode;
          this.containFreight = res.containFreight;
          this.form.projectName = res.projectName;
          this.form.projectCode = res.projectCode;
          this.form.projectId = res.projectId;
          this.form.findSourceTitle = res.findSourceTitle
          this.form.detail = res.detail;
          this.form.expiryDate = res.expiryDate;
          this.form.remark = res.remark;
          this.form.findSourceCode = res.findSourceCode;
          this.form.checkStatus = res.checkStatus;
          this.detailList = res.infos;

          let totalPrice1 = 0;
          for (let n = 0; n < this.detailList.length; n++) {
            totalPrice1 +=
              Number(this.detailList[n].demandCount) *
              Number(this.detailList[n].sellingPrice);
          }
          this.totalPrice = totalPrice1;

          this.form.id = res.id;
          this.handlerAddress(this.form.address);
        })
        .catch(() => { });
    },
    // 获取城市列表
    async getCityList() {
      var res = await getCityData();
      if (res.status === 200) {
        const json1 = JSON.parse(
          JSON.stringify(res.data).replace(/v/g, "value")
        );
        const json2 = JSON.parse(JSON.stringify(json1).replace(/n/g, "label"));
        const json3 = JSON.parse(
          JSON.stringify(json2).replace(/c/g, "children")
        );
        json3.forEach((i) => {
          i.children.forEach((j) => {
            j.children.forEach((k) => {
              delete k.children;
            });
          });
        });
        this.options = json3;
      } else {
        this.$message.warning(res.msg);
      }
    },
    beforeInit() {
      this.url = "/system/user/getBpmUser";
      this.params = {
        page: this.page,
        size: this.size,
      };
      const query = this.query;
      const type = query.type;
      const value = query.value;
      if (type && value) {
        this.params[type] = value;
      }
      return true;
    },
    dialogRes(a, data) {
      data.storeId = a.id;
      data.productName = a.productName;
      data.productCode = a.productCode;
      data.unitName = a.unitName;
      data.price = a.price;
      this.isUpdate = !this.isUpdate;
      this.dialogTableVisible = false;
    },
    namesRes(a) {
      this.form.projectSMuser = a.projectSMuser;
      this.form.projectSMcode = a.projectSMcode;
      this.form.projectName = a.projectName;
      this.form.projectId = a.id;
      this.form.projectCode = a.projectCode;
      this.form.deptId = a.deptId;
      this.form.deptName = a.deptName;
      this.dialogName = false;
    },
    checkGoods(data) {
      this.dialogTableVisible = true;
      this.uItem = data;
    },
    checkName(data) {
      this.dialogName = true;
      this.nItem = data;
    },
    async onSubmit() {
      let address = {};
      address.cityId = this.form.address.cityId;
      address.city = this.form.address.city;
      address.cityCode = this.form.address.cityCode;
      address.districtCode = this.form.address.districtCode;
      address.provinceCode = this.form.address.provinceCode;
      address.province = this.form.address.province;
      address.district = this.form.address.district;
      let para = {};

      para["projcetSMuser"] = this.form.projectSMuser;
      para["projcetSMcode"] = this.form.projectSMcode;
      para["username"] = this.form.username;
      para["phone"] = this.form.phone;
      para["id"] = this.form.id;
      para["status"] = this.form.status;
      para["address"] = address;
      para["deptId"] = this.form.deptId;
      para["deptName"] = this.form.deptName;
      para["remark"] = this.form.remark;
      para["expectDate"] = this.form.expectDate;
      para["demandDate"] = this.form.demandDate;
      para["detailList"] = this.detailList;
      para["projectName"] = this.form.projectName;
      para["projectId"] = this.form.projectId;
      para["projectCode"] = this.form.projectCode;
      para["detail"] = this.form.detail;
      para["createUserType"] = 1;

      var res = await saveInventory(para);
      if (res.code === 200) {
        this.$router.push("indexpage/noticedetail");
      } else {
        this.$message.warning(res.msg);
      }
    },

    addList() {
      var list = {
        lineCode: this.setLineCode,
        materialCode: "",
        materialName: "",
        storeId: "",
        price: "",
        remark: "",
        demandCount: null,
        productName: "",
        productCode: "",
        itemSpecs: "",
        unitCode: "",
        unitName: "",
      };
      this.detailList.push(list);
    },
    delList(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });

          this.detailList.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 选择省市区
    handleChange(val) {
      if (val.length) {
        this.options.forEach((i) => {
          if (i.value === val[0]) {
            this.form.address.province = i.label;
            this.form.address.provinceCode = i.value;
            i.children.forEach((j) => {
              if (j.value === val[1]) {
                this.form.address.city = j.label;
                this.form.address.cityCode = j.value;
                // this.form.address.cityId = j.value;
                j.children.forEach((k) => {
                  if (k.value === val[2]) {
                    this.form.address.district = k.label;
                    this.form.address.districtCode = k.value;
                  }
                });
              }
            });
          }
        });
      } else {
        this.form.address = {
          city: null,
          province: null,
          district: null,
        };
      }
    },
    handlerAddress(val) {
      let addressVal = [];
      if (val) {
        this.options.forEach((i) => {
          if (i.label === val.province) {
            addressVal.push(i.value);
            i.children.forEach((j) => {
              if (j.label === val.city) {
                addressVal.push(j.value);
                j.children.forEach((k) => {
                  if (k.label === val.district) {
                    addressVal.push(k.value);
                  }
                });
              }
            });
          }
        });

        this.addressVal = addressVal;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.addressList2 {
  .addressBox2 {
    padding: 20px;
    border: 2px solid #ccc;
    margin-bottom: 20px;
    font-size: 18px;

    p {
      line-height: 1.7;
    }

    .edit,
    .defaultAddress,
    .setDefault {
      line-height: 1.7;
    }
  }

  .active2 {
    border-color: #e4393c;
    background-color: #fffbfa;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/addInventory/detail.vue